var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01562 6.55469V10.185C2.01562 11.6888 4.45336 12.9077 7.46105 12.9077C10.4687 12.9077 12.9065 11.6888 12.9065 10.185V6.55469",
    stroke: "#04102A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01562 10.1855V13.8158C2.01562 15.3197 4.45336 16.5385 7.46105 16.5385C8.85598 16.5385 10.1275 16.2753 11.0913 15.8442",
    stroke: "#04102A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.46105 9.27745C10.4685 9.27745 12.9065 8.05845 12.9065 6.55474C12.9065 5.05103 10.4685 3.83203 7.46105 3.83203C4.45362 3.83203 2.01562 5.05103 2.01562 6.55474C2.01562 8.05845 4.45362 9.27745 7.46105 9.27745Z",
    stroke: "#04102A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0918 13.8145V17.4447C11.0918 18.9486 13.5295 20.1674 16.5372 20.1674C19.5449 20.1674 21.9826 18.9486 21.9826 17.4447V13.8145",
    stroke: "#04102A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5372 16.5372C19.5446 16.5372 21.9826 15.3182 21.9826 13.8145C21.9826 12.3108 19.5446 11.0918 16.5372 11.0918C13.5298 11.0918 11.0918 12.3108 11.0918 13.8145C11.0918 15.3182 13.5298 16.5372 16.5372 16.5372Z",
    stroke: "#04102A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.2550ea6e.svg";
export { ForwardRef as ReactComponent };